<po-page-edit
  p-title="Pré-cadastro Cliente"
  [p-breadcrumb]="breadcrumb"
>
  <form #formPrincipal="ngForm">
    <po-widget class="po-sm-12 po-md-12 po-lg-12"
      p-title="Informações do Cliente"
    >
      <po-select class="po-md-12 po-xl-3"
        name="CA1TIPO"
        p-label="Tipo"
        [(ngModel)]="preCliente.CA1TIPO"
        [p-options]="[
          {value: 'F', label: 'Consumidor Final'},
          {value: 'R', label: 'Revendedor'},
          {value: 'S', label: 'Solidário'},
          {value: 'X', label: 'Estrangeiro'},
          {value: 'L', label: 'Produtor Rural'},
        ]"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        (p-change)="alteraTipo($event)"
      ></po-select>
      <po-select class="po-md-12 po-xl-2"
        name="CA1PESSOA"
        p-label="Tipo de Pessoa"
        [(ngModel)]="preCliente.CA1PESSOA"
        [p-options]="[
          {value: 'F', label: 'Física'},
          {value: 'J', label: 'Jurídica'},
        ]"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
      ></po-select>
      @if (preCliente.CA1TIPO!=='X') {
        <po-input class="po-md-12 po-xl-7"
          name="CA1CGC"
          [p-label]="preCliente.CA1PESSOA==='F'?'CPF':preCliente.CA1PESSOA==='J'?'CNPJ':'CPF/CNPJ'"
          [(ngModel)]="preCliente.CA1CGC"
          p-required="true"
          [p-disabled]="bloqueiaDadosSolicitante"
          [p-mask]="preCliente.CA1PESSOA==='F'?'999.999.999-99':'AA.AAA.AAA/AAAA-99'"
          p-clean="true"
          (p-change)="validarCIP()"
          p-maxlength="18"
        ></po-input>
      } @else {
        <po-input class="po-md-12 po-xl-7"
          name="CA1CGC"
          p-label="Customer ID NUMBER"
          [(ngModel)]="preCliente.CA1CGC"
          p-required="true"
          [p-disabled]="bloqueiaDadosSolicitante"
          p-clean="true"
          p-maxlength="18"
        ></po-input>
      }
      <po-input class="po-md-12 po-xl-7"
        name="CA1NOME"
        p-label="Razão Social"
        [(ngModel)]="preCliente.CA1NOME"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="40"
        [p-minlength]="5"
        [pattern]="patternPadraoTotvs"
        p-error-pattern="Tamanho entre 5 40 caracteres ou Caracteres inválidos"
        (p-change-model)="preCliente.CA1NOME = preCliente.CA1NOME.toUpperCase();"
      ></po-input>
      <po-input class="po-md-12 po-xl-5"
        name="CA1NREDUZ"
        p-label="Nome Fantasia"
        [(ngModel)]="preCliente.CA1NREDUZ"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="20"
        [p-minlength]="5"
        [pattern]="patternPadraoTotvs"
        p-error-pattern="Tamanho entre 5 e 20 caracteres ou Caracteres inválidos"
        (p-change-model)="preCliente.CA1NREDUZ = preCliente.CA1NREDUZ.toUpperCase();"
      ></po-input>
      <po-input class="po-md-12 po-xl-3"
        name="CA1RG"
        p-label="RG"
        [(ngModel)]="preCliente.CA1RG"
        [p-required]="preCliente.CA1PESSOA==='F'"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="15"
        [p-minlength]="0"
      ></po-input>
      @if (preCliente.CA1TIPO!=='X') {
        <po-input class="po-md-12 po-xl-2"
          name="CA1CEP"
          p-label="CEP"
          [(ngModel)]="preCliente.CA1CEP"
          p-mask="99.999-999"
          [p-disabled]="bloqueiaDadosSolicitante"
          (p-change)="alteraCep($event)"
          (p-blur)="alteraCep($event)"
          (keyup.enter)="alteraCep($event)"
          [p-clean]="true"
          [p-required]="true"
          [p-maxlength]="10"
          [p-minlength]="10"
        ></po-input>
      } @else {
        <po-input class="po-md-12 po-xl-2"
          name="CA1CEP"
          p-label="CEP Export"
          [(ngModel)]="preCliente.CA1CEP"
          p-required="true"
          [p-disabled]="bloqueiaDadosSolicitante"
          [p-maxlength]="10"
          [p-minlength]="5"
        ></po-input>
      }
      <po-select class="po-md-12 po-xl-3"
        #poSelectEst
        name="CA1EST"
        p-label="Estado"
        [(ngModel)]="preCliente.CA1EST"
        [p-options]="listaEstado"
        (p-change)="selecionarEstado()"
        [p-disabled]="false"
        [p-required]="true"
      ></po-select>
      @if (preCliente.CA1TIPO === 'X'){
        <po-input class="po-md-12 po-xl-4"
          name="CA1ESTADO"
          p-label="Nome Estado"
          [(ngModel)]="preCliente.CA1ESTADO"
          [p-disabled]="bloqueiaDadosSolicitante"
          [p-maxlength]="20"
          p-clean="true"
        ></po-input>
      }
      @if (preCliente.CA1TIPO !== 'X') {
        <po-lookup class="po-md-12 po-xl-4"
          name="CA1COD_MUN"
          p-label="Município IBGE (*)"
          [(ngModel)]="preCliente.CA1COD_MUN"
          p-field-label="CCC2MUN"
          p-field-value="CCC2CODMUN"
          [p-columns]="columnsMunicipioIBGEFilters"
          [p-field-format]="fieldFormaterMunicipioIBGEFilters"
          [p-filter-service]="municipioIBGEService"
          [p-advanced-filters]="advancedMunicipioIBGEFilters"
          [p-literals]="{ modalTitle: 'MunicipioIBGE' }"
          (p-selected)="municipioIBGESelecionado($event)"
          [p-disabled]="bloqueiaDadosSolicitante || municipioIBGEService.estado"
          p-required="true"
          [p-clean]="true"
        ></po-lookup>
      } @else {
        <po-input class="po-md-12 po-xl-6"
          name="CA1MUN"
          p-label="Município"
          [(ngModel)]="preCliente.CA1MUN"
          p-required="true"
          [p-disabled]="bloqueiaDadosSolicitante"
          p-clean="true"
          [p-maxlength]="60"
          [p-minlength]="5"
          [pattern]="patternPadraoTotvs"
          p-error-pattern="Tamanho entre 5 e 60 caracteres ou Caracteres inválidos"
          (p-change-model)="preCliente.CA1MUN = preCliente.CA1MUN.toUpperCase();"
        ></po-input>
      }
      <po-input class="po-md-12 po-xl-6"
        name="CA1END"
        p-label="Endereço"
        [(ngModel)]="preCliente.CA1END"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="60"
        [p-minlength]="5"
        [pattern]="patternPadraoTotvs"
        p-error-pattern="Tamanho entre 5 e 60 caracteres ou Caracteres inválidos"
        (p-change-model)="preCliente.CA1END = preCliente.CA1END.toUpperCase();"
      ></po-input>
      <po-input class="po-md-12 po-xl-6"
        name="CA1COMPLEM"
        p-label="Complemento"
        [(ngModel)]="preCliente.CA1COMPLEM"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="50"
        [p-minlength]="0"
        [pattern]="patternPadraoTotvs"
        p-error-pattern="Caracteres inválidos"
      ></po-input>
      <po-input class="po-md-12 po-xl-6"
        name="CA1BAIRRO"
        p-label="Bairro"
        [(ngModel)]="preCliente.CA1BAIRRO"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        [p-maxlength]="30"
        [p-minlength]="5"
        [pattern]="patternPadraoTotvs"
        p-error-pattern="Tamanho entre 5 e 30 caracteres ou Caracteres inválidos"
        (p-change-model)="preCliente.CA1BAIRRO = preCliente.CA1BAIRRO.toUpperCase();"
      ></po-input>
      <po-combo class="po-md-12 po-xl-6"
        name="CA1CODPAIS"
        p-label="País"
        [(ngModel)]="preCliente.CA1CODPAIS"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrlocalizacao/pais"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
      ></po-combo>
      <po-input class="po-md-12 po-xl-1"
        name="CA1DDD"
        p-label="DDD"
        [(ngModel)]="preCliente.CA1DDD"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-mask="999"
        p-clean="true"
      ></po-input>
      <po-input class="po-md-12 po-xl-2"
        name="CA1TEL"
        [p-label]="preCliente.CA1TIPO!=='X'?'Fone':'Fone Export'"
        [(ngModel)]="preCliente.CA1TEL"
        [p-disabled]="bloqueiaDadosSolicitante"
        [p-maxlength]="15"
        [p-minlength]="8"
        p-clean="true"
      ></po-input>
      <po-input class="po-md-12 po-xl-2"
        name="CA1FAX"
        [p-label]="preCliente.CA1TIPO!=='X'?'Fax':'Fax Export'"
        [(ngModel)]="preCliente.CA1FAX"
        [p-disabled]="bloqueiaDadosSolicitante"
        [p-maxlength]="15"
        [p-minlength]="0"
        p-clean="true"
      ></po-input>
      <po-input class="po-md-12 po-xl-4"
        name="CA1CONTATO"
        p-label="Contato"
        [(ngModel)]="preCliente.CA1CONTATO"
        [p-disabled]="bloqueiaDadosSolicitante"
        [p-maxlength]="15"
        [p-minlength]="0"
        [pattern]="patternPadraoTotvs"
        p-error-pattern="Caracteres inválidos"
        p-clean="true"
        (p-change-model)="preCliente.CA1CONTATO = preCliente.CA1CONTATO.toUpperCase();"
      ></po-input>
      <po-input class="po-md-12 po-xl-3"
        name="CA1INSCR"
        p-label="Inscrição Estadual"
        [(ngModel)]="preCliente.CA1INSCR"
        [p-disabled]="bloqueiaDadosSolicitante || preCliente.CA1TIPO==='X'"
        [p-maxlength]="18"
        [p-minlength]="0"
        p-clean="true"
        [p-required]="preCliente.CA1PESSOA!=='F'"
      ></po-input>

      <po-input class="po-md-12 po-xl-3"
        name="CA1INSCRM"
        p-label="Inscrição Municipal"
        [(ngModel)]="preCliente.CA1INSCRM"
        [p-disabled]="bloqueiaDadosSolicitante"
        [p-maxlength]="18"
        [p-minlength]="0"
        [p-disabled]="preCliente.CA1TIPO==='X'"
        [p-required]="preCliente.CA1PESSOA!=='F'"
      ></po-input>

      <po-input class="po-sm-12 po-md-6 po-lg-6"
        p-icon="po-icon-mail"
        name="CA1EMAIL"
        [(ngModel)]="preCliente.CA1EMAIL"
        p-label="Email"
        p-required="true"
        p-placeholder="example@domain.com"
        [p-disabled]="bloqueiaDadosSolicitante"
        [p-maxlength]="100"
        [p-minlength]="0"
      ></po-input>
      <po-url class="po-sm-12 po-md-6 po-lg-6"
        name="CA1HPAGE"
        [(ngModel)]="preCliente.CA1HPAGE"
        p-label="Home Page"
        p-placeholder="www.domain.com"
        [p-disabled]="bloqueiaDadosSolicitante"
        [p-maxlength]="30"
        [p-minlength]="0"
      ></po-url>
      <po-combo class="po-sm-6 po-md-6 po-lg-6"
        name="CA1NATUREZ"
        p-label="Natureza"
        [(ngModel)]="preCliente.CA1NATUREZ"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrnatureza"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
      ></po-combo>
      <po-select class="po-sm-6 po-md-6 po-lg-6"
        name="CA1CONTA"
        p-label="Conta"
        [(ngModel)]="preCliente.CA1CONTA"
        [p-options]="listaContaContabil"
        p-icon="po-icon-search"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
      ></po-select>
      <po-combo class="po-sm-6 po-md-6 po-lg-6"
        name="CA1GRPTRIB"
        p-label="Grupo Tributário"
        [(ngModel)]="preCliente.CA1GRPTRIB"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrbase/zprcombo/GRUPOCLI"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
      ></po-combo>
      <po-decimal class="po-sm-6 po-md-3 po-lg-3"
        name="NA1LC"
        p-label="Limite de Crédito"
        [(ngModel)]="preCliente.NA1LC"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-decimals-length="0"
      ></po-decimal>
      <po-select class="po-sm-6 po-md-4 po-lg-3"
        name="CURGENTE"
        p-label="Urgente?"
        [(ngModel)]="urgente"
        [p-options]="[
          {value: 'N', label: 'Não'},
          {value: 'S', label: 'Sim'},
        ]"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
      ></po-select>
    </po-widget>

    @if ( liberaAvancarProcesso ) {
      <po-widget class="po-sm-12 po-md-12 po-lg-12"
        p-title="Observações"
      >
        <po-textarea class="po-sm-12 po-md-12 po-lg-12"
          name="OBSERVACAO"
          [(ngModel)]="historico"
          p-rows="4"
          p-required="true"
          p-minlength="10"
        ></po-textarea>
        <po-button class="po-sm-6 po-md-6 po-lg-6"
          p-label="{{ [' ','2'].includes(processoCadastro.CSTATUS) ? 'Cancelar' : 'Recusar' }} Processo"
          p-danger="true"
          (p-click)="cancelarRecusarTela()"
        ></po-button>
        <po-button class="po-sm-6 po-md-6 po-lg-6"
          p-label="Avançar Processo"
          (p-click)="confirmarTela()"
        ></po-button>
      </po-widget>
    }
  </form>
  <po-divider class="po-row" p-label="Histórico do Processo"></po-divider>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-items]="tabelaHistorico"
    [p-columns]="tabelaHistoricoColunas"
    p-container="true"
    p-spacing="small"
  ></po-table>
</po-page-edit>
